import React from "react";
import { useParams } from "react-router-dom";
import Theme404 from "../../layout/404";

import user_interest_list from "./user_interest.list";
import user_interest_edit from "./user_interest.edit";

/**
 *   Create index file for User_interest
 */

export default function List_user_interest() {
  let useParam = {} as any;
  useParam = useParams();
  let Param = useParam.slug || "list";

  let ActualPage: any;
  switch (Param) {
    case "list":
      ActualPage = user_interest_list;
      break;

    case "edit":
      ActualPage = user_interest_edit;
      break;

    case "new":
      ActualPage = user_interest_edit;
      break;

    default:
      ActualPage = Theme404;
      break;
  }

  return <>{<ActualPage />}</>;
}

